import { getDB } from "./schema";
import type { Conversation } from "./types";

export async function putConversation(conv: Conversation): Promise<void> {
  const db = await getDB();
  await db.put("conversations", conv);
}

export async function getConversation(
  id: string,
): Promise<Conversation | undefined> {
  const db = await getDB();
  return db.get("conversations", id);
}

/** Plus récentes d'abord, les épinglées en tête (tri stable : chaque groupe
 *  garde son ordre chronologique). */
export async function listConversations(): Promise<Conversation[]> {
  const db = await getDB();
  const all = await db.getAllFromIndex("conversations", "by-updatedAt");
  return pinnedFirst(all.reverse());
}

export function pinnedFirst(list: Conversation[]): Conversation[] {
  return [...list].sort((a, b) => Number(!!b.pinned) - Number(!!a.pinned));
}

/** `updatedAt` n'est pas touché : épingler ne compte pas comme une activité. */
export async function setConversationPinned(id: string, pinned: boolean): Promise<void> {
  const db = await getDB();
  const tx = db.transaction("conversations", "readwrite");
  const conv = await tx.store.get(id);
  if (conv) {
    conv.pinned = pinned;
    await tx.store.put(conv);
  }
  await tx.done;
}

export async function deleteConversation(id: string): Promise<void> {
  const db = await getDB();
  const tx = db.transaction(["conversations", "messages"], "readwrite");
  await tx.objectStore("conversations").delete(id);
  const msgs = await tx
    .objectStore("messages")
    .index("by-conversation")
    .getAllKeys(id);
  await Promise.all(msgs.map((key) => tx.objectStore("messages").delete(key)));
  await tx.done;
}

export async function touchConversation(id: string): Promise<void> {
  const db = await getDB();
  const tx = db.transaction("conversations", "readwrite");
  const conv = await tx.store.get(id);
  if (conv) {
    conv.updatedAt = Date.now();
    await tx.store.put(conv);
  }
  await tx.done;
}
